import { ZAKAZKA_CONTROL as NAME } from '../../constants';

export { DMS_MODULE, ZAKAZKA_CONTROL as NAME } from '../../constants';
export const DEPENDENT_TABLES = <const>[NAME];
